
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOnIec as ObiOnIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-on-iec.js';
 
 
 

 
 export const ObiOnIec = createComponent({
   react: React,
   tagName: 'obi-on-iec',
   elementClass: ObiOnIecElement,
   events: {
     
   }
  });
 
 